import React from 'react';
import { ArrowLeft, User } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { useTheme } from '../../context/ThemeContext';
import { formatPrice } from '../../utils/formatters';

export default function ProfileDetails({ onBack }) {
  const { colors } = useTheme();
  const { user } = useAuth();
  return (
    <div className="space-y-4">
      <div className="flex items-center space-x-3">
        <button onClick={() => onBack()} className="app-card p-1.5 rounded-md" style={{ background: `linear-gradient(135deg, ${colors.accent}12 0%, ${colors.accent}04 100%)` }}>
          <ArrowLeft className="w-4 h-4" style={{ color: colors.primaryText }} />
        </button>
        <h1 className="text-[17px] font-bold" style={{ color: colors.primaryText }}>Profile Details</h1>
      </div>
      
      <div className="flex flex-col items-center py-4">
        <div className="w-16 h-16 rounded-full flex items-center justify-center mb-3" style={{ backgroundColor: colors.accent }}>
          <User className="w-8 h-8 text-white" />
        </div>
        <h2 className="text-[14px] font-bold" style={{ color: colors.primaryText }}>{user?.full_name || 'Demo Trader'}</h2>
        <p className="text-[13px]" style={{ color: colors.secondaryText }}>{user?.email || 'demo@tradereflex.ai'}</p>
        {user?.plan && (
          <span className={`mt-1 px-1.5 py-1 rounded-full text-[13px] font-semibold uppercase tracking-wide ${
            user.plan === 'admin' ? 'bg-red-500/20 text-red-400' :
            user.plan === 'premium' ? 'bg-indigo-500/20 text-indigo-400' :
            'bg-gray-500/20 text-gray-400'
          }`}>
            {user.plan}
          </span>
        )}
      </div>

      <div className="app-card rounded-lg p-1.5 space-y-2.5" style={{ background: `linear-gradient(135deg, ${colors.accent}12 0%, ${colors.accent}04 100%)`, borderWidth: '1px', borderColor: colors.border }}>
        <div className="flex justify-between text-[14px]">
          <span style={{ color: colors.secondaryText }}>Account Type</span>
          <span className="font-medium" style={{ color: colors.primaryText }}>Paper Trading</span>
        </div>
        <div className="flex justify-between text-[14px]">
          <span style={{ color: colors.secondaryText }}>Virtual Balance</span>
          <span className="font-medium" style={{ color: colors.profit }}>{formatPrice(user?.virtual_balance || 1000000)}</span>
        </div>
        <div className="flex justify-between text-[14px]">
          <span style={{ color: colors.secondaryText }}>Member Since</span>
          <span className="font-medium" style={{ color: colors.primaryText }}>January 2025</span>
        </div>
      </div>
    </div>
  );
}
